import Gallery from './gallery'
import AlbumName from './name'

export default { Gallery, AlbumName }
